module.exports = __webpack_public_path__ + "static/media/robot.ed4dbcd6.png";